export const educationData = {
  educationHeaders: [
    { heading: "Educational Details" },
    { columns: ["Degree", "Subject", "University", "Year"] },
  ],
  educationalDetails: [
    {
      Degree: "Ph.D.",
      Subject: "Water Resources Engineering",
      University: "Tokyo Tech, Japan",
      Year: "2022",
    },
    {
      Degree: "M. Tech.",
      Subject: "Groundwater Hydrology",
      University: "IIT Roorkee",
      Year: "2019",
    },
    {
      Degree: "B. Tech.",
      Subject: "Civil Engineering",
      University: "IIT Roorkee",
      Year: "2017",
    },
  ],
};
export const professionalData = {
  professionalHeaders: [
    { heading: "Professional Background" },
    { columns: ["From", "To", "Designation", "Organisation"] },
  ],
  professionalDetails: [
    {
      From: "Mar 2023",
      To: "Present",
      Designation: "Assistant Professor",
      Organisation: "IIT Roorkee",
    },
    {
      From: "Nov 2022",
      To: "Mar 2023",
      Designation: "C V Raman Postdoc Fellow",
      Organisation: "IISc Bangalore",
    },
  ],
};
export const honorsData = {
  honorsHeaders: [
    { heading: "Honors and Awards" },
    { columns: ["Award", "University", "Year"] },
  ],
  honorslDetails: [
    {
      Award: "MEXT Research Scholarship",
      University: "Tokyo Tech, Japan",
      Year: "2019",
    },
    {
      Award: "Department Gold Medal",
      University: "IIT Roorkee",
      Year: "2019",
    },
    {
      Award: "DAAD IIT Master Sandwich Felloship",
      University: "TU Dresden, Germany",
      Year: "2018",
    },
    {
      Award: "Summer Undergraduate Research Award (SURA)",
      University: "IIT Roorkee",
      Year: "2015",
    },
  ],
};
